// Service worker registration (after the first screen has painted) and the one-time "works
// offline now" note. New versions are taken into use by the update gate (shell/UpdateGate.tsx) at
// the next open or return to the app, never here mid-use: this only keeps asking for them (hourly
// and when the app comes back to the foreground; iOS checks a Home Screen app rarely by itself).
import { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useT } from '../i18n';
import { useApp } from '../state/store';

const HOUR = 60 * 60 * 1000;

export function UpdatePrompt() {
  const t = useT();
  const inSession = useApp((s) => s.inSession);
  const reg = useRef<ServiceWorkerRegistration | null>(null);
  const {
    offlineReady: [offlineReady, setOfflineReady],
  } = useRegisterSW({
    onRegisteredSW(_url, r) {
      reg.current = r ?? null;
      if (r) setInterval(() => void r.update().catch(() => undefined), HOUR);
    },
  });

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') void reg.current?.update().catch(() => undefined);
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  if (offlineReady && !inSession) {
    return (
      <div className="toast" role="status">
        <span>{t.update.offlineReady}</span>
        <div className="toast-actions">
          <button type="button" className="btn btn-small" onClick={() => setOfflineReady(false)}>
            {t.update.ok}
          </button>
        </div>
      </div>
    );
  }
  return null;
}
